import { RoutePathsSubMenu } from '../../RoutePathsSubMenu'
import { RoadEditsSubMenu } from '../../RoadEditsSubMenu'
import { RegionsSubMenu } from '../../RegionsSubMenu'
import { OrdersSubMenu } from '../../OrdersSubMenu'
import { DepotsSubMenu } from '../../DepotsSubMenu'

interface Props {
  menuOpen: boolean
}

export function RmSubMenu(props: Props) {
  const { menuOpen } = props

  return (
    <>
      <OrdersSubMenu parentOpen={menuOpen} />
      <RoutePathsSubMenu parentOpen={menuOpen} />
      <DepotsSubMenu parentOpen={menuOpen} />
      <RegionsSubMenu parentOpen={menuOpen} />
      <RoadEditsSubMenu parentOpen={menuOpen} />
    </>
  )
}
